import {getCurrentYear} from '../../utils/commons'
import BestPetEssentialsPicksLogo from './logo'
import {bestPetEssentialsPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestpetessentialspicks' as const,
  camelCaseUrl: 'BestPetEssentialsPicks.com',
  domainType: 'picks' as const,
  siteName: 'Best Pet Essentials Picks',
  logo: <BestPetEssentialsPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/bestpetessentialspicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-65M5GZ6S0V',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestPetEssentialsPicks.com – Trusted Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Choose the best pet supplies with expert reviews. From food to grooming, find trusted recommendations to keep your pets happy and healthy.`,
    styles: bestPetEssentialsPicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
